/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';
import { TargetDomain } from 'data/targetDomain/targetDomain.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  targetDomain?: TargetDomain,
): FormTemplate | undefined {
  if (template == null) {
    return template;
  }

  return cloneDeep(template);
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptTargetDomainTemplate(
  template: FormTemplate,
): FormTemplate {

  const clonedTemplate = cloneDeep(template);

  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  return clonedTemplate;
}

export function adaptFormData(
  data: TargetDomain,
): TargetDomain {

  return cloneDeep(data);
}

export function adaptTargetDomainFormData(
  targetDomain: TargetDomain,
): TargetDomain {

  const clonedTargetDomain = cloneDeep(targetDomain);

  return clonedTargetDomain;
}
